import Vue from 'vue'

Vue.filter('formatDate', formatDate)
Vue.filter('formatDateTime', formatDateTime)
Vue.filter('formatDateTimeShort', formatDateTimeShort)
Vue.filter('parseTime', parseTime)
Vue.filter('formatTime', formatTime)

/**
 * 日期格式化 年-月-日
 * @param value
 * @returns {string}
 */
export function formatDate(value) {
  if (!value) {
    return ''
  }
  if (value) {
    // 处理时区
    value = myTime(value)
    let date = new Date(value)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }
    return year + '-' + month + '-' + day
  } else {
    return ''
  }
}

/**
 * 时间格式化
 * @param value  年-月-日  时-分-秒
 * @returns {string}
 */
export function formatDateTime(value) {
  if (!value) {
    return ''
  }
  // 处理时区
  value = myTime(value)
  let date = new Date(value)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let seconds = date.getSeconds()
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  if (hours < 10) {
    hours = '0' + hours
  }
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
}

/**
 * 时间格式化
 * @param value  年-月-日  时-分
 * @returns {string}
 */
export function formatDateTimeShort(value) {
  if (!value) {
    return ''
  }
  // 处理时区
  value = myTime(value)
  let date = new Date(value)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  if (hours < 10) {
    hours = '0' + hours
  }
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()
  const diff = (now - d) / 1000
  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * 处理时区
 * @param date
 * @returns {string}
 */
function myTime(date) {
  if (date.indexOf('T') !== -1) {
    let arr = date.split('T')
    let d = arr[0]
    let darr = d.split('-')
    let t = arr[1]
    let tarr = t.split('.000')
    let marr = tarr[0].split(':')
    let dd = parseInt(darr[0]) + '/' + parseInt(darr[1]) + '/' + parseInt(darr[2]) + ' ' + parseInt(marr[0]) + ':' + parseInt(marr[1]) + ':' + parseInt(marr[2])
    return dd
  } else {
    return date
  }
}

/**
 * 又一个自定义事件格式化函数
 * @param fmt
 * @param date
 * @returns {*}
 */
export function dateFormat2(fmt, date) {
  date = new Date(date)
  return dateFormatUtil(fmt, date)
}

function dateFormatUtil(fmt, date) {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'H+': date.getHours(), // 小时
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

/**
 * 又一个自定义事件格式化函数
 * @param fmt
 * @param date 日期格式
 * @returns {*}
 */
export function dateFormat3(fmt, date) {
  return dateFormatUtil(fmt, date)
}



// WEBPACK FOOTER //
// ./src/utils/format/date.js